/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendActualCapexDto } from '../models/backend-actual-capex-dto';
import { BackendActualCreditDto } from '../models/backend-actual-credit-dto';
import { BackendActualExpenseAggregateDto } from '../models/backend-actual-expense-aggregate-dto';
import { BackendActualLeasingContractDto } from '../models/backend-actual-leasing-contract-dto';
import { BackendActualOwnFundDto } from '../models/backend-actual-own-fund-dto';
import { BackendActualSaleDto } from '../models/backend-actual-sale-dto';
import { BackendActualTaxDto } from '../models/backend-actual-tax-dto';
import { BackendActualWorkingCapitalDto } from '../models/backend-actual-working-capital-dto';
import { monitoringActualsCapexsCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-capexs-copy-create';
import { MonitoringActualsCapexsCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-copy-create';
import { monitoringActualsCapexsCreate } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create';
import { monitoringActualsCapexsCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create-form-data';
import { MonitoringActualsCapexsCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create-form-data';
import { MonitoringActualsCapexsCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create';
import { monitoringActualsCapexsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create-x-www-form-urlencoded';
import { MonitoringActualsCapexsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-create-x-www-form-urlencoded';
import { monitoringActualsCapexsDestroy } from '../fn/monitoring-actuals/monitoring-actuals-capexs-destroy';
import { MonitoringActualsCapexsDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-destroy';
import { monitoringActualsCapexsList } from '../fn/monitoring-actuals/monitoring-actuals-capexs-list';
import { MonitoringActualsCapexsList$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-list';
import { monitoringActualsCapexsPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update';
import { monitoringActualsCapexsPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update-form-data';
import { MonitoringActualsCapexsPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update-form-data';
import { MonitoringActualsCapexsPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update';
import { monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update-x-www-form-urlencoded';
import { MonitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-partial-update-x-www-form-urlencoded';
import { monitoringActualsCapexsRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-capexs-retrieve';
import { MonitoringActualsCapexsRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-retrieve';
import { monitoringActualsCapexsUpdate } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update';
import { monitoringActualsCapexsUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update-form-data';
import { MonitoringActualsCapexsUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update-form-data';
import { MonitoringActualsCapexsUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update';
import { monitoringActualsCapexsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update-x-www-form-urlencoded';
import { MonitoringActualsCapexsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-capexs-update-x-www-form-urlencoded';
import { monitoringActualsCreditsCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-credits-copy-create';
import { MonitoringActualsCreditsCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-copy-create';
import { monitoringActualsCreditsCreate } from '../fn/monitoring-actuals/monitoring-actuals-credits-create';
import { monitoringActualsCreditsCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-credits-create-form-data';
import { MonitoringActualsCreditsCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-create-form-data';
import { MonitoringActualsCreditsCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-create';
import { monitoringActualsCreditsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-credits-create-x-www-form-urlencoded';
import { MonitoringActualsCreditsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-create-x-www-form-urlencoded';
import { monitoringActualsCreditsDestroy } from '../fn/monitoring-actuals/monitoring-actuals-credits-destroy';
import { MonitoringActualsCreditsDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-destroy';
import { monitoringActualsCreditsList } from '../fn/monitoring-actuals/monitoring-actuals-credits-list';
import { MonitoringActualsCreditsList$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-list';
import { monitoringActualsCreditsPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update';
import { monitoringActualsCreditsPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update-form-data';
import { MonitoringActualsCreditsPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update-form-data';
import { MonitoringActualsCreditsPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update';
import { monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update-x-www-form-urlencoded';
import { MonitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-partial-update-x-www-form-urlencoded';
import { monitoringActualsCreditsRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-credits-retrieve';
import { MonitoringActualsCreditsRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-retrieve';
import { monitoringActualsCreditsUpdate } from '../fn/monitoring-actuals/monitoring-actuals-credits-update';
import { monitoringActualsCreditsUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-credits-update-form-data';
import { MonitoringActualsCreditsUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-update-form-data';
import { MonitoringActualsCreditsUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-update';
import { monitoringActualsCreditsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-credits-update-x-www-form-urlencoded';
import { MonitoringActualsCreditsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-credits-update-x-www-form-urlencoded';
import { monitoringActualsExpensesList } from '../fn/monitoring-actuals/monitoring-actuals-expenses-list';
import { MonitoringActualsExpensesList$Params } from '../fn/monitoring-actuals/monitoring-actuals-expenses-list';
import { monitoringActualsLeasingsCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-leasings-copy-create';
import { MonitoringActualsLeasingsCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-copy-create';
import { monitoringActualsLeasingsCreate } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create';
import { monitoringActualsLeasingsCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create-form-data';
import { MonitoringActualsLeasingsCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create-form-data';
import { MonitoringActualsLeasingsCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create';
import { monitoringActualsLeasingsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create-x-www-form-urlencoded';
import { MonitoringActualsLeasingsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-create-x-www-form-urlencoded';
import { monitoringActualsLeasingsDestroy } from '../fn/monitoring-actuals/monitoring-actuals-leasings-destroy';
import { MonitoringActualsLeasingsDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-destroy';
import { monitoringActualsLeasingsList } from '../fn/monitoring-actuals/monitoring-actuals-leasings-list';
import { MonitoringActualsLeasingsList$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-list';
import { monitoringActualsLeasingsPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update';
import { monitoringActualsLeasingsPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update-form-data';
import { MonitoringActualsLeasingsPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update-form-data';
import { MonitoringActualsLeasingsPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update';
import { monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update-x-www-form-urlencoded';
import { MonitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-partial-update-x-www-form-urlencoded';
import { monitoringActualsLeasingsRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-leasings-retrieve';
import { MonitoringActualsLeasingsRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-retrieve';
import { monitoringActualsLeasingsUpdate } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update';
import { monitoringActualsLeasingsUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update-form-data';
import { MonitoringActualsLeasingsUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update-form-data';
import { MonitoringActualsLeasingsUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update';
import { monitoringActualsLeasingsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update-x-www-form-urlencoded';
import { MonitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-leasings-update-x-www-form-urlencoded';
import { monitoringActualsOwnFundCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-copy-create';
import { MonitoringActualsOwnFundCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-copy-create';
import { monitoringActualsOwnFundCreate } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create';
import { monitoringActualsOwnFundCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create-form-data';
import { MonitoringActualsOwnFundCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create-form-data';
import { MonitoringActualsOwnFundCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create';
import { monitoringActualsOwnFundCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create-x-www-form-urlencoded';
import { MonitoringActualsOwnFundCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-create-x-www-form-urlencoded';
import { monitoringActualsOwnFundDestroy } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-destroy';
import { MonitoringActualsOwnFundDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-destroy';
import { monitoringActualsOwnFundList } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-list';
import { MonitoringActualsOwnFundList$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-list';
import { monitoringActualsOwnFundPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update';
import { monitoringActualsOwnFundPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update-form-data';
import { MonitoringActualsOwnFundPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update-form-data';
import { MonitoringActualsOwnFundPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update';
import { monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update-x-www-form-urlencoded';
import { MonitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-partial-update-x-www-form-urlencoded';
import { monitoringActualsOwnFundRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-retrieve';
import { MonitoringActualsOwnFundRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-retrieve';
import { monitoringActualsOwnFundUpdate } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update';
import { monitoringActualsOwnFundUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update-form-data';
import { MonitoringActualsOwnFundUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update-form-data';
import { MonitoringActualsOwnFundUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update';
import { monitoringActualsOwnFundUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update-x-www-form-urlencoded';
import { MonitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-own-fund-update-x-www-form-urlencoded';
import { monitoringActualsSalesCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-sales-copy-create';
import { MonitoringActualsSalesCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-copy-create';
import { monitoringActualsSalesCreate } from '../fn/monitoring-actuals/monitoring-actuals-sales-create';
import { monitoringActualsSalesCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-sales-create-form-data';
import { MonitoringActualsSalesCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-create-form-data';
import { MonitoringActualsSalesCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-create';
import { monitoringActualsSalesCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-sales-create-x-www-form-urlencoded';
import { MonitoringActualsSalesCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-create-x-www-form-urlencoded';
import { monitoringActualsSalesDestroy } from '../fn/monitoring-actuals/monitoring-actuals-sales-destroy';
import { MonitoringActualsSalesDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-destroy';
import { monitoringActualsSalesList } from '../fn/monitoring-actuals/monitoring-actuals-sales-list';
import { MonitoringActualsSalesList$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-list';
import { monitoringActualsSalesPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update';
import { monitoringActualsSalesPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update-form-data';
import { MonitoringActualsSalesPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update-form-data';
import { MonitoringActualsSalesPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update';
import { monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update-x-www-form-urlencoded';
import { MonitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-partial-update-x-www-form-urlencoded';
import { monitoringActualsSalesRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-sales-retrieve';
import { MonitoringActualsSalesRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-retrieve';
import { monitoringActualsSalesUpdate } from '../fn/monitoring-actuals/monitoring-actuals-sales-update';
import { monitoringActualsSalesUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-sales-update-form-data';
import { MonitoringActualsSalesUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-update-form-data';
import { MonitoringActualsSalesUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-update';
import { monitoringActualsSalesUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-sales-update-x-www-form-urlencoded';
import { MonitoringActualsSalesUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-sales-update-x-www-form-urlencoded';
import { monitoringActualsTaxesCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-taxes-copy-create';
import { MonitoringActualsTaxesCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-copy-create';
import { monitoringActualsTaxesCreate } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create';
import { monitoringActualsTaxesCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create-form-data';
import { MonitoringActualsTaxesCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create-form-data';
import { MonitoringActualsTaxesCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create';
import { monitoringActualsTaxesCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create-x-www-form-urlencoded';
import { MonitoringActualsTaxesCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-create-x-www-form-urlencoded';
import { monitoringActualsTaxesDestroy } from '../fn/monitoring-actuals/monitoring-actuals-taxes-destroy';
import { MonitoringActualsTaxesDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-destroy';
import { monitoringActualsTaxesList } from '../fn/monitoring-actuals/monitoring-actuals-taxes-list';
import { MonitoringActualsTaxesList$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-list';
import { monitoringActualsTaxesPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update';
import { monitoringActualsTaxesPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update-form-data';
import { MonitoringActualsTaxesPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update-form-data';
import { MonitoringActualsTaxesPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update';
import { monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update-x-www-form-urlencoded';
import { MonitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-partial-update-x-www-form-urlencoded';
import { monitoringActualsTaxesRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-taxes-retrieve';
import { MonitoringActualsTaxesRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-retrieve';
import { monitoringActualsTaxesUpdate } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update';
import { monitoringActualsTaxesUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update-form-data';
import { MonitoringActualsTaxesUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update-form-data';
import { MonitoringActualsTaxesUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update';
import { monitoringActualsTaxesUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update-x-www-form-urlencoded';
import { MonitoringActualsTaxesUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-taxes-update-x-www-form-urlencoded';
import { monitoringActualsWorkingCapitalCopyCreate } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-copy-create';
import { MonitoringActualsWorkingCapitalCopyCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-copy-create';
import { monitoringActualsWorkingCapitalCreate } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create';
import { monitoringActualsWorkingCapitalCreate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create-form-data';
import { MonitoringActualsWorkingCapitalCreate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create-form-data';
import { MonitoringActualsWorkingCapitalCreate$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create';
import { monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create-x-www-form-urlencoded';
import { MonitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-create-x-www-form-urlencoded';
import { monitoringActualsWorkingCapitalDestroy } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-destroy';
import { MonitoringActualsWorkingCapitalDestroy$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-destroy';
import { monitoringActualsWorkingCapitalList } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-list';
import { MonitoringActualsWorkingCapitalList$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-list';
import { monitoringActualsWorkingCapitalPartialUpdate } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update';
import { monitoringActualsWorkingCapitalPartialUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update-form-data';
import { MonitoringActualsWorkingCapitalPartialUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update-form-data';
import { MonitoringActualsWorkingCapitalPartialUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update';
import { monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update-x-www-form-urlencoded';
import { MonitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-partial-update-x-www-form-urlencoded';
import { monitoringActualsWorkingCapitalRetrieve } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-retrieve';
import { MonitoringActualsWorkingCapitalRetrieve$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-retrieve';
import { monitoringActualsWorkingCapitalUpdate } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update';
import { monitoringActualsWorkingCapitalUpdate$FormData } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update-form-data';
import { MonitoringActualsWorkingCapitalUpdate$FormData$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update-form-data';
import { MonitoringActualsWorkingCapitalUpdate$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update';
import { monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update-x-www-form-urlencoded';
import { MonitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actuals/monitoring-actuals-working-capital-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringActualsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringActualsCapexsList()` */
  static readonly MonitoringActualsCapexsListPath = '/api/monitoring/actuals/capexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsList$Response(
    params?: MonitoringActualsCapexsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualCapexDto>>> {
    return monitoringActualsCapexsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsList(
    params?: MonitoringActualsCapexsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualCapexDto>> {
    return this.monitoringActualsCapexsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualCapexDto>>): Array<BackendActualCapexDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsCreate()` */
  static readonly MonitoringActualsCapexsCreatePath = '/api/monitoring/actuals/capexs/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsCreate$Response(
    params: MonitoringActualsCapexsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsCreate(
    params: MonitoringActualsCapexsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCapexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsCapexsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsCreate$FormData$Response(
    params: MonitoringActualsCapexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsCreate$FormData(
    params: MonitoringActualsCapexsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsRetrieve()` */
  static readonly MonitoringActualsCapexsRetrievePath = '/api/monitoring/actuals/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsRetrieve$Response(
    params: MonitoringActualsCapexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsRetrieve(
    params: MonitoringActualsCapexsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsUpdate()` */
  static readonly MonitoringActualsCapexsUpdatePath = '/api/monitoring/actuals/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsUpdate$Response(
    params: MonitoringActualsCapexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsUpdate(
    params: MonitoringActualsCapexsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCapexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsCapexsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsUpdate$FormData$Response(
    params: MonitoringActualsCapexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsUpdate$FormData(
    params: MonitoringActualsCapexsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsDestroy()` */
  static readonly MonitoringActualsCapexsDestroyPath = '/api/monitoring/actuals/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsDestroy$Response(
    params: MonitoringActualsCapexsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsCapexsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsDestroy(
    params: MonitoringActualsCapexsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsCapexsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsPartialUpdate()` */
  static readonly MonitoringActualsCapexsPartialUpdatePath = '/api/monitoring/actuals/capexs/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsPartialUpdate$Response(
    params: MonitoringActualsCapexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCapexsPartialUpdate(
    params: MonitoringActualsCapexsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsPartialUpdate$FormData$Response(
    params: MonitoringActualsCapexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCapexsPartialUpdate$FormData(
    params: MonitoringActualsCapexsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCapexsCopyCreate()` */
  static readonly MonitoringActualsCapexsCopyCreatePath = '/api/monitoring/actuals/capexs/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCapexsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsCopyCreate$Response(
    params: MonitoringActualsCapexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCapexDto>> {
    return monitoringActualsCapexsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCapexsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCapexsCopyCreate(
    params: MonitoringActualsCapexsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCapexDto> {
    return this.monitoringActualsCapexsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCapexDto>): BackendActualCapexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsList()` */
  static readonly MonitoringActualsCreditsListPath = '/api/monitoring/actuals/credits/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsList$Response(
    params?: MonitoringActualsCreditsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualCreditDto>>> {
    return monitoringActualsCreditsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsList(
    params?: MonitoringActualsCreditsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualCreditDto>> {
    return this.monitoringActualsCreditsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualCreditDto>>): Array<BackendActualCreditDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsCreate()` */
  static readonly MonitoringActualsCreditsCreatePath = '/api/monitoring/actuals/credits/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsCreate$Response(
    params: MonitoringActualsCreditsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsCreate(
    params: MonitoringActualsCreditsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCreditsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsCreditsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsCreate$FormData$Response(
    params: MonitoringActualsCreditsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsCreate$FormData(
    params: MonitoringActualsCreditsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsRetrieve()` */
  static readonly MonitoringActualsCreditsRetrievePath = '/api/monitoring/actuals/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsRetrieve$Response(
    params: MonitoringActualsCreditsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsRetrieve(
    params: MonitoringActualsCreditsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsUpdate()` */
  static readonly MonitoringActualsCreditsUpdatePath = '/api/monitoring/actuals/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsUpdate$Response(
    params: MonitoringActualsCreditsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsUpdate(
    params: MonitoringActualsCreditsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCreditsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsCreditsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsUpdate$FormData$Response(
    params: MonitoringActualsCreditsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsUpdate$FormData(
    params: MonitoringActualsCreditsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsDestroy()` */
  static readonly MonitoringActualsCreditsDestroyPath = '/api/monitoring/actuals/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsDestroy$Response(
    params: MonitoringActualsCreditsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsCreditsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsDestroy(
    params: MonitoringActualsCreditsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsCreditsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsPartialUpdate()` */
  static readonly MonitoringActualsCreditsPartialUpdatePath = '/api/monitoring/actuals/credits/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsPartialUpdate$Response(
    params: MonitoringActualsCreditsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsCreditsPartialUpdate(
    params: MonitoringActualsCreditsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsPartialUpdate$FormData$Response(
    params: MonitoringActualsCreditsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsCreditsPartialUpdate$FormData(
    params: MonitoringActualsCreditsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsCreditsCopyCreate()` */
  static readonly MonitoringActualsCreditsCopyCreatePath = '/api/monitoring/actuals/credits/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsCreditsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsCopyCreate$Response(
    params: MonitoringActualsCreditsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualCreditDto>> {
    return monitoringActualsCreditsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsCreditsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsCreditsCopyCreate(
    params: MonitoringActualsCreditsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualCreditDto> {
    return this.monitoringActualsCreditsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualCreditDto>): BackendActualCreditDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsExpensesList()` */
  static readonly MonitoringActualsExpensesListPath = '/api/monitoring/actuals/expenses/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsExpensesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsExpensesList$Response(
    params?: MonitoringActualsExpensesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualExpenseAggregateDto>>> {
    return monitoringActualsExpensesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsExpensesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsExpensesList(
    params?: MonitoringActualsExpensesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualExpenseAggregateDto>> {
    return this.monitoringActualsExpensesList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendActualExpenseAggregateDto>>): Array<BackendActualExpenseAggregateDto> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsList()` */
  static readonly MonitoringActualsLeasingsListPath = '/api/monitoring/actuals/leasings/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsList$Response(
    params?: MonitoringActualsLeasingsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualLeasingContractDto>>> {
    return monitoringActualsLeasingsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsList(
    params?: MonitoringActualsLeasingsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualLeasingContractDto>> {
    return this.monitoringActualsLeasingsList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendActualLeasingContractDto>>): Array<BackendActualLeasingContractDto> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsCreate()` */
  static readonly MonitoringActualsLeasingsCreatePath = '/api/monitoring/actuals/leasings/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsCreate$Response(
    params: MonitoringActualsLeasingsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsCreate(
    params: MonitoringActualsLeasingsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsLeasingsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsLeasingsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsCreate$FormData$Response(
    params: MonitoringActualsLeasingsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsCreate$FormData(
    params: MonitoringActualsLeasingsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsRetrieve()` */
  static readonly MonitoringActualsLeasingsRetrievePath = '/api/monitoring/actuals/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsRetrieve$Response(
    params: MonitoringActualsLeasingsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsRetrieve(
    params: MonitoringActualsLeasingsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsUpdate()` */
  static readonly MonitoringActualsLeasingsUpdatePath = '/api/monitoring/actuals/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsUpdate$Response(
    params: MonitoringActualsLeasingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsUpdate(
    params: MonitoringActualsLeasingsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsUpdate$FormData$Response(
    params: MonitoringActualsLeasingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsUpdate$FormData(
    params: MonitoringActualsLeasingsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsDestroy()` */
  static readonly MonitoringActualsLeasingsDestroyPath = '/api/monitoring/actuals/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsDestroy$Response(
    params: MonitoringActualsLeasingsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsLeasingsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsDestroy(
    params: MonitoringActualsLeasingsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsLeasingsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsPartialUpdate()` */
  static readonly MonitoringActualsLeasingsPartialUpdatePath = '/api/monitoring/actuals/leasings/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsPartialUpdate$Response(
    params: MonitoringActualsLeasingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsLeasingsPartialUpdate(
    params: MonitoringActualsLeasingsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsPartialUpdate$FormData$Response(
    params: MonitoringActualsLeasingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsLeasingsPartialUpdate$FormData(
    params: MonitoringActualsLeasingsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsLeasingsCopyCreate()` */
  static readonly MonitoringActualsLeasingsCopyCreatePath = '/api/monitoring/actuals/leasings/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsLeasingsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsCopyCreate$Response(
    params: MonitoringActualsLeasingsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
    return monitoringActualsLeasingsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsLeasingsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsLeasingsCopyCreate(
    params: MonitoringActualsLeasingsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualLeasingContractDto> {
    return this.monitoringActualsLeasingsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualLeasingContractDto>): BackendActualLeasingContractDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundList()` */
  static readonly MonitoringActualsOwnFundListPath = '/api/monitoring/actuals/own-fund/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundList$Response(
    params?: MonitoringActualsOwnFundList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualOwnFundDto>>> {
    return monitoringActualsOwnFundList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundList(
    params?: MonitoringActualsOwnFundList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualOwnFundDto>> {
    return this.monitoringActualsOwnFundList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualOwnFundDto>>): Array<BackendActualOwnFundDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundCreate()` */
  static readonly MonitoringActualsOwnFundCreatePath = '/api/monitoring/actuals/own-fund/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundCreate$Response(
    params: MonitoringActualsOwnFundCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundCreate(
    params: MonitoringActualsOwnFundCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOwnFundCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundCreate$XWwwFormUrlencoded(
    params: MonitoringActualsOwnFundCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundCreate$FormData$Response(
    params: MonitoringActualsOwnFundCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundCreate$FormData(
    params: MonitoringActualsOwnFundCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundRetrieve()` */
  static readonly MonitoringActualsOwnFundRetrievePath = '/api/monitoring/actuals/own-fund/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundRetrieve$Response(
    params: MonitoringActualsOwnFundRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundRetrieve(
    params: MonitoringActualsOwnFundRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundUpdate()` */
  static readonly MonitoringActualsOwnFundUpdatePath = '/api/monitoring/actuals/own-fund/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundUpdate$Response(
    params: MonitoringActualsOwnFundUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundUpdate(
    params: MonitoringActualsOwnFundUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundUpdate$FormData$Response(
    params: MonitoringActualsOwnFundUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundUpdate$FormData(
    params: MonitoringActualsOwnFundUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundDestroy()` */
  static readonly MonitoringActualsOwnFundDestroyPath = '/api/monitoring/actuals/own-fund/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundDestroy$Response(
    params: MonitoringActualsOwnFundDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsOwnFundDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundDestroy(
    params: MonitoringActualsOwnFundDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsOwnFundDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundPartialUpdate()` */
  static readonly MonitoringActualsOwnFundPartialUpdatePath = '/api/monitoring/actuals/own-fund/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundPartialUpdate$Response(
    params: MonitoringActualsOwnFundPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOwnFundPartialUpdate(
    params: MonitoringActualsOwnFundPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundPartialUpdate$FormData$Response(
    params: MonitoringActualsOwnFundPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOwnFundPartialUpdate$FormData(
    params: MonitoringActualsOwnFundPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOwnFundCopyCreate()` */
  static readonly MonitoringActualsOwnFundCopyCreatePath = '/api/monitoring/actuals/own-fund/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOwnFundCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundCopyCreate$Response(
    params: MonitoringActualsOwnFundCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOwnFundDto>> {
    return monitoringActualsOwnFundCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOwnFundCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOwnFundCopyCreate(
    params: MonitoringActualsOwnFundCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOwnFundDto> {
    return this.monitoringActualsOwnFundCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOwnFundDto>): BackendActualOwnFundDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesList()` */
  static readonly MonitoringActualsSalesListPath = '/api/monitoring/actuals/sales/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesList$Response(
    params?: MonitoringActualsSalesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualSaleDto>>> {
    return monitoringActualsSalesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesList(
    params?: MonitoringActualsSalesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualSaleDto>> {
    return this.monitoringActualsSalesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualSaleDto>>): Array<BackendActualSaleDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesCreate()` */
  static readonly MonitoringActualsSalesCreatePath = '/api/monitoring/actuals/sales/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesCreate$Response(
    params: MonitoringActualsSalesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesCreate(
    params: MonitoringActualsSalesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesCreate$XWwwFormUrlencoded(
    params: MonitoringActualsSalesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesCreate$FormData$Response(
    params: MonitoringActualsSalesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesCreate$FormData(
    params: MonitoringActualsSalesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesRetrieve()` */
  static readonly MonitoringActualsSalesRetrievePath = '/api/monitoring/actuals/sales/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesRetrieve$Response(
    params: MonitoringActualsSalesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesRetrieve(
    params: MonitoringActualsSalesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesUpdate()` */
  static readonly MonitoringActualsSalesUpdatePath = '/api/monitoring/actuals/sales/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesUpdate$Response(
    params: MonitoringActualsSalesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesUpdate(
    params: MonitoringActualsSalesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsSalesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesUpdate$FormData$Response(
    params: MonitoringActualsSalesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesUpdate$FormData(
    params: MonitoringActualsSalesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesDestroy()` */
  static readonly MonitoringActualsSalesDestroyPath = '/api/monitoring/actuals/sales/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesDestroy$Response(
    params: MonitoringActualsSalesDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsSalesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesDestroy(params: MonitoringActualsSalesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.monitoringActualsSalesDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesPartialUpdate()` */
  static readonly MonitoringActualsSalesPartialUpdatePath = '/api/monitoring/actuals/sales/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesPartialUpdate$Response(
    params: MonitoringActualsSalesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalesPartialUpdate(
    params: MonitoringActualsSalesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesPartialUpdate$FormData$Response(
    params: MonitoringActualsSalesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalesPartialUpdate$FormData(
    params: MonitoringActualsSalesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalesCopyCreate()` */
  static readonly MonitoringActualsSalesCopyCreatePath = '/api/monitoring/actuals/sales/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalesCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesCopyCreate$Response(
    params: MonitoringActualsSalesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSaleDto>> {
    return monitoringActualsSalesCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalesCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalesCopyCreate(
    params: MonitoringActualsSalesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSaleDto> {
    return this.monitoringActualsSalesCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSaleDto>): BackendActualSaleDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesList()` */
  static readonly MonitoringActualsTaxesListPath = '/api/monitoring/actuals/taxes/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesList$Response(
    params?: MonitoringActualsTaxesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualTaxDto>>> {
    return monitoringActualsTaxesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesList(
    params?: MonitoringActualsTaxesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualTaxDto>> {
    return this.monitoringActualsTaxesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualTaxDto>>): Array<BackendActualTaxDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesCreate()` */
  static readonly MonitoringActualsTaxesCreatePath = '/api/monitoring/actuals/taxes/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesCreate$Response(
    params: MonitoringActualsTaxesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesCreate(
    params: MonitoringActualsTaxesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsTaxesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesCreate$XWwwFormUrlencoded(
    params: MonitoringActualsTaxesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesCreate$FormData$Response(
    params: MonitoringActualsTaxesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesCreate$FormData(
    params: MonitoringActualsTaxesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesRetrieve()` */
  static readonly MonitoringActualsTaxesRetrievePath = '/api/monitoring/actuals/taxes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesRetrieve$Response(
    params: MonitoringActualsTaxesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesRetrieve(
    params: MonitoringActualsTaxesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesUpdate()` */
  static readonly MonitoringActualsTaxesUpdatePath = '/api/monitoring/actuals/taxes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesUpdate$Response(
    params: MonitoringActualsTaxesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesUpdate(
    params: MonitoringActualsTaxesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsTaxesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsTaxesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesUpdate$FormData$Response(
    params: MonitoringActualsTaxesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesUpdate$FormData(
    params: MonitoringActualsTaxesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesDestroy()` */
  static readonly MonitoringActualsTaxesDestroyPath = '/api/monitoring/actuals/taxes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesDestroy$Response(
    params: MonitoringActualsTaxesDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsTaxesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesDestroy(params: MonitoringActualsTaxesDestroy$Params, context?: HttpContext): Observable<void> {
    return this.monitoringActualsTaxesDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesPartialUpdate()` */
  static readonly MonitoringActualsTaxesPartialUpdatePath = '/api/monitoring/actuals/taxes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesPartialUpdate$Response(
    params: MonitoringActualsTaxesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsTaxesPartialUpdate(
    params: MonitoringActualsTaxesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesPartialUpdate$FormData$Response(
    params: MonitoringActualsTaxesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsTaxesPartialUpdate$FormData(
    params: MonitoringActualsTaxesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsTaxesCopyCreate()` */
  static readonly MonitoringActualsTaxesCopyCreatePath = '/api/monitoring/actuals/taxes/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsTaxesCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesCopyCreate$Response(
    params: MonitoringActualsTaxesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualTaxDto>> {
    return monitoringActualsTaxesCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsTaxesCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsTaxesCopyCreate(
    params: MonitoringActualsTaxesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualTaxDto> {
    return this.monitoringActualsTaxesCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualTaxDto>): BackendActualTaxDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalList()` */
  static readonly MonitoringActualsWorkingCapitalListPath = '/api/monitoring/actuals/working-capital/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalList$Response(
    params?: MonitoringActualsWorkingCapitalList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualWorkingCapitalDto>>> {
    return monitoringActualsWorkingCapitalList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalList(
    params?: MonitoringActualsWorkingCapitalList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualWorkingCapitalDto>> {
    return this.monitoringActualsWorkingCapitalList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendActualWorkingCapitalDto>>): Array<BackendActualWorkingCapitalDto> => r.body,
      ),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalCreate()` */
  static readonly MonitoringActualsWorkingCapitalCreatePath = '/api/monitoring/actuals/working-capital/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalCreate$Response(
    params: MonitoringActualsWorkingCapitalCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalCreate(
    params: MonitoringActualsWorkingCapitalCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded(
    params: MonitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalCreate$FormData$Response(
    params: MonitoringActualsWorkingCapitalCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalCreate$FormData(
    params: MonitoringActualsWorkingCapitalCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalRetrieve()` */
  static readonly MonitoringActualsWorkingCapitalRetrievePath = '/api/monitoring/actuals/working-capital/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalRetrieve$Response(
    params: MonitoringActualsWorkingCapitalRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalRetrieve(
    params: MonitoringActualsWorkingCapitalRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalUpdate()` */
  static readonly MonitoringActualsWorkingCapitalUpdatePath = '/api/monitoring/actuals/working-capital/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalUpdate$Response(
    params: MonitoringActualsWorkingCapitalUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalUpdate(
    params: MonitoringActualsWorkingCapitalUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalUpdate$FormData$Response(
    params: MonitoringActualsWorkingCapitalUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalUpdate$FormData(
    params: MonitoringActualsWorkingCapitalUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalDestroy()` */
  static readonly MonitoringActualsWorkingCapitalDestroyPath = '/api/monitoring/actuals/working-capital/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalDestroy$Response(
    params: MonitoringActualsWorkingCapitalDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsWorkingCapitalDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalDestroy(
    params: MonitoringActualsWorkingCapitalDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsWorkingCapitalDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalPartialUpdate()` */
  static readonly MonitoringActualsWorkingCapitalPartialUpdatePath = '/api/monitoring/actuals/working-capital/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalPartialUpdate$Response(
    params: MonitoringActualsWorkingCapitalPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsWorkingCapitalPartialUpdate(
    params: MonitoringActualsWorkingCapitalPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalPartialUpdate$FormData$Response(
    params: MonitoringActualsWorkingCapitalPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsWorkingCapitalPartialUpdate$FormData(
    params: MonitoringActualsWorkingCapitalPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsWorkingCapitalCopyCreate()` */
  static readonly MonitoringActualsWorkingCapitalCopyCreatePath = '/api/monitoring/actuals/working-capital/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsWorkingCapitalCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalCopyCreate$Response(
    params: MonitoringActualsWorkingCapitalCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualWorkingCapitalDto>> {
    return monitoringActualsWorkingCapitalCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsWorkingCapitalCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsWorkingCapitalCopyCreate(
    params: MonitoringActualsWorkingCapitalCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualWorkingCapitalDto> {
    return this.monitoringActualsWorkingCapitalCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualWorkingCapitalDto>): BackendActualWorkingCapitalDto => r.body),
    );
  }
}
